//***********************************************************
// Angular
//***********************************************************
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

//***********************************************************
// MJ
//***********************************************************

import { AuthServicesModule, RedirectComponent } from '@memberjunction/ng-auth-services';

//***********************************************************
//MSAL
//***********************************************************
import { MsalGuardConfiguration } from '@azure/msal-angular';
import { InteractionType } from '@azure/msal-browser';

//***********************************************************
// Project stuff
//***********************************************************
import { AppComponent } from './app.component';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AcsAlertComponent } from './components/shared/acs-alert/acs-alert';
import { AcsButtonComponent } from './components/shared/acs-button/acs-button';
import { AcsAnnouncementModalComponent } from './components/shared/acs-announcement-modal/acs-announcement-modal';
import { AcsAnnouncementViewerComponent } from './components/shared/acs-announcement-viewer/acs-announcement-viewer';
import { AcsAnnouncementBannerComponent } from './components/shared/acs-announcement-banner/acs-announcement-banner';
import { AcsAnnouncementManagementComponent } from './components/shared/acs-announcement-management/acs-announcement-management';
import { AcsModalComponent } from './components/shared/acs-modal/acs-modal';
import { AcsDataGridComponent } from './components/shared/acs-data-grid/acs-data-grid';
import { AcsDocumentUploadModalComponent } from './components/shared/acs-document-upload-modal/acs-document-upload-modal';
import { AcsDocumentManagerComponent } from './components/shared/acs-document-manager/acs-document-manager';
import { AcsFileManagerComponent } from './components/shared/acs-file-manager/acs-file-manager';
import { AcsInputComponent } from './components/shared/acs-input/acs-input';
import { AcsLoadingSpinnerComponent } from './components/shared/acs-loading-spinner/acs-loading-spinner';
import { AcsStatsCardComponent } from './components/shared/acs-stats-card/acs-stats-card';
import { NotificationContainerComponent } from './components/shared/notification-container/notification-container';
import { ThemeSelectorComponent } from './components/shared/theme-selector/theme-selector';
import { LoginPageComponent } from './components/login-page/landing-page';
import { AcsNavigationComponent } from './components/shared/acs-navigation/acs-navigation.component';
import { AcsSummaryComponent } from './components/shared/acs-summary/acs-summary.component';
import { DashboardComponent } from './components/dashboard/dashboard';
import { MemberRosterComponent } from './components/member-roster/member-roster';
import { ChapterDuesComponent } from './components/chapter-dues/chapter-dues';
import { ChapterOfficersComponent } from './components/chapter-officers/chapter-officers';
import { MemberChapterDuesComponent } from './components/member-chapter-dues/member-chapter-dues';
import { ThemeConfiguruationComponent } from './components/theme-configuration/theme-configuration';
import { AllChaptersComponent } from './components/all-chapters/all-chapters';
import { ChapterDetailsComponent } from './components/chapter-details/chapter-details';
import { SessionWarningModalComponent } from './components/shared/session-warning-modal/session-warning-modal';
import { AdminUsersComponent } from './components/admin-users/admin-users';
import { ImpersonationBannerComponent } from './components/shared/impersonation-banner/impersonation-banner.component';
import { ImpersonationControlComponent } from './components/shared/impersonation-control/impersonation-control.component';
import { ImpersonationLogsComponent } from './components/impersonation-logs/impersonation-logs';
import { PortalAccessLogsComponent } from './components/portal-access-logs/portal-access-logs';
import { NoAccessComponent } from './components/no-access/no-access.component';

/**
 * Set your default interaction type for MSALGuard here. If you have any
 * additional scopes you want the user to consent upon login, add them here as well.
 */
export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
  };
}

const projectDeclarations = [
  AcsAlertComponent,
  AcsAnnouncementModalComponent,
  AcsAnnouncementViewerComponent,
  AcsAnnouncementBannerComponent,
  AcsAnnouncementManagementComponent,
  AcsButtonComponent,
  AcsDataGridComponent,
  AcsDocumentUploadModalComponent,
  AcsDocumentManagerComponent,
  AcsFileManagerComponent,
  AcsInputComponent,
  AcsLoadingSpinnerComponent,
  AcsModalComponent,
  AcsNavigationComponent,
  AcsStatsCardComponent,
  NotificationContainerComponent,
  ThemeSelectorComponent,

  ImpersonationBannerComponent,
  ImpersonationControlComponent,

  LoginPageComponent,
  DashboardComponent,
  AcsSummaryComponent,
  AllChaptersComponent,
  ChapterDetailsComponent,
  ChapterDuesComponent,
  ChapterOfficersComponent,
  MemberRosterComponent,
  MemberChapterDuesComponent,
  ThemeConfiguruationComponent,
  SessionWarningModalComponent,
  AdminUsersComponent,
  ImpersonationLogsComponent,
  PortalAccessLogsComponent,
  NoAccessComponent
]

@NgModule({
  declarations: [
    AppComponent,
    ...projectDeclarations
  ],
  imports: [
    AppRoutingModule,
    CommonModule,
    BrowserModule,
    FormsModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    AuthServicesModule.forRoot(environment)
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())],
  bootstrap: [AppComponent, RedirectComponent],
})
export class AppModule {}
